<button
  *ngIf="!isDataGridHeaderAction || !isPhoneSize; else mobileAction"
  class="basic-button {{ 'button-' + color }} {{ 'button-' + size }} {{
    'button-' + mode
  }}"
  [ngClass]="{ 'button-shadow': !shadow, 'button-washed': isWashed }"
  mat-raised-button
  [disabled]="disabled"
  matTooltipClass="cm-tooltip typography__tooltip {{ tooltipClass }}"
  matTooltipShowDelay="1500"
  matTooltipHideDelay="500"
  [matTooltipPosition]="tooltipPosition"
  [matTooltip]="tooltipMessage"
  [attr.data-cy]="dataCy ?? 'basic-button'"
  (click)="handleClick()"
>
  <span class="{{ 'typography__button-' + size }}">
    <ng-content></ng-content>
  </span>
</button>

<ng-template #mobileAction>
  <cm-icon-button
    [icon]="mobileActionIconName"
    size="large"
    color="primary"
    [disabled]="disabled"
    (click)="handleClick()"
  ></cm-icon-button>
</ng-template>
